import React from 'react';
import {
  Box,
  Stack
} from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import * as ds from './dataService';
import { filterInstallationsVar } from 'modules/common/layer00/reactiveVariables';
import {
  SelectInstallationAreaField,
  SelectInstallationRoomField,
  SelectInstallationTypeField
} from 'modules/components/layer04';
import { InstallationSearchBar } from 'modules/components/layer05';



export type InstallationFilterBarProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationFilterBarProps) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const installationFilter = useReactiveVar(filterInstallationsVar);
  const form = ds.useFormState();

  return (
    <Stack
      flex='1 1 0'
      direction='row'
      columnGap='1rem'
    >
      <Box
        display='flex'
        columnGap='1rem'
        flex='1 1 0'
      >
        <SelectInstallationAreaField.FC
          form={form}
          fieldName='areaId'
          inputLabel='Area'
        />
        <SelectInstallationTypeField.FC
          form={form}
          fieldName='installationTypeId'
          inputLabel='Category'
        />
        <SelectInstallationRoomField.FC
          form={form}
          fieldName='roomName'
          inputLabel='Room'
        />
      </Box>
      <Box
        display='flex'
        columnGap='1rem'
        flex='1 1 0'
      >
        <InstallationSearchBar.FC />
      </Box>
    </Stack>
  );
};
